import {gql} from "@apollo/client";
export const removeResellerBySupplier = gql`
mutation RemoveResellerBySupplier($supplierId: ID!, $resellerId: ID!) {
    removeResellerBySupplier(supplier_id: $supplierId, reseller_id: $resellerId)
  }
`;